import React from 'react';
import { Input, Label, InputGroup, InputGroupText } from 'reactstrap';
import PropTypes from 'prop-types';

class LookupDropDown extends React.Component {

    getItems = () => {
        let options = [];

        // Show "Select" option only if no valid option is chosen
        if (!this.props.value) {
            options.push(
                <option key="default" value="">
                    Select
                </option>
            );
        }

        // Add placeholder if provided (only if it's different from "Select")
        if (this.props.dropdownPlaceholder && this.props.dropdownPlaceholder !== "Select" && !this.props.value) {
            options.unshift(
                <option key="placeholder" value="" disabled hidden>
                    {this.props.dropdownPlaceholder}
                </option>
            );
        }

        // Generate dropdown options
        this.props.lookups.forEach((lookup, index) => {
            const value = lookup.lookupId ?? lookup[this.props.idSelector] ?? ''; // Fallback to empty string
            const label = lookup.name ?? lookup[this.props.nameSelector] ?? 'Select'; // Fallback to "Select"

            options.push(
                <option key={`${this.props.name}-${index}`} value={value}>
                    {label}
                </option>
            );
        });

        return options;
    };

    render() {
        const showColon = this.props.name === 'journalTypeId' || this.props.name === 'journalStatusTypeId' ? '' : ':';
        const disableDropDown = this.props.disablePersonTypeDropdown && this.props.disablePersonTypeDropdown === true ? true : false
        return (
            <React.Fragment>
                {this.props.inline ? (
                    <InputGroup>
                        <InputGroupText>{this.props.label}:</InputGroupText>
                        <Input
                            disabled={true}
                            name={this.props.name}
                            type='select'
                            onChange={this.props.onChange}
                            value={this.props.value ?? ''}
                        >
                            {this.getItems()}
                        </Input>
                    </InputGroup>
                ) : (
                    <React.Fragment>
                        <Label>{this.props.label}{showColon}</Label>
                        <Input
                            disabled={disableDropDown}
                            invalid={!this.props.value}
                            name={this.props.name}
                            type='select'
                            onChange={this.props.onChange}
                            value={this.props.value ?? ''}
                        >
                            {this.getItems()}
                        </Input>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

LookupDropDown.propTypes = {
    label: PropTypes.string.isRequired,
    lookups: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dropdownPlaceholder: PropTypes.string,
    idSelector: PropTypes.string,
    nameSelector: PropTypes.string,
    inline: PropTypes.bool
};

export default LookupDropDown;
